import { Dropdown, MenuProps } from 'antd';
import React from 'react';

import { MoreOutlined } from '@ant-design/icons';
import {
  BlockRuleTypeOptions,
  EVENT_NAME_WITH_BLOCK_RULE,
} from '@components/block-event-single/constant/constant';
import {
  EPanelOpenMethod,
  useBlockEventSinglePanelStore,
} from '@components/block-event-single/store';
import { getDefaultBlockEventData } from '@components/block-event-single/utils/initializeUtils';
import { useTopPanelStore } from '@hooks';
import { useGetBlockEvents, useGetBlockEventsName } from '@src/api/emp/queryHooks';
import { useCreatePermissions } from '@src/hooks/usePermissions';
import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';

interface IProps {
  eventName: string;
  mappedStatus: boolean;
}

// CE-10566 add default value for parameter s.
const startsWithConviva = (eventName: string = ''): boolean => {
  return eventName.startsWith('conviva_');
};

export const AllEventMenu: React.FC<IProps> = ({ eventName, mappedStatus }) => {
  const { data: blockedEvents, refetch: blockedEventsRefetch } = useGetBlockEvents();
  const { data: blockedEventsName } = useGetBlockEventsName();
  const { workbenchMode } = useInitialInfoStore();

  const [setPanelOpenMethod, setBlockType, setBlockEventsSingleDataGroup] =
    useBlockEventSinglePanelStore((state) => [
      state.setPanelOpenMethod,
      state.setBlockType,
      state.setBlockEventsSingleDataGroup,
    ]);
  const { openBlockEventSinglePanel } = useTopPanelStore();
  const hasCreate = useCreatePermissions();
  const isBlocked = (blockedEventsName ?? []).includes(eventName);
  const canBlock =
    EVENT_NAME_WITH_BLOCK_RULE.includes(eventName) ||
    (!startsWithConviva(eventName) && !mappedStatus);

  const handleBlockEventClick = () => {
    openBlockEventSinglePanel();
    const singleBlockEventData = getDefaultBlockEventData();
    singleBlockEventData.event_name = eventName;
    // If found, this is the 'View Block Details'
    const findBlockEvent = (blockedEvents?.data ?? []).find(
      (item) => item.event_name === eventName,
    );
    if (findBlockEvent && findBlockEvent.block_rules.length > 0) {
      singleBlockEventData.block_rules = findBlockEvent.block_rules;
      setBlockType(BlockRuleTypeOptions[1].value);
    } else {
      setBlockType(BlockRuleTypeOptions[0].value);
    }
    setBlockEventsSingleDataGroup([singleBlockEventData]);
  };

  const handleBlockEventMenuItemClick = () => {
    setPanelOpenMethod(EPanelOpenMethod.CREATE);
    handleBlockEventClick();
  };

  const handleViewBlockEventMenuItemClick = () => {
    blockedEventsRefetch();
    setPanelOpenMethod(EPanelOpenMethod.EDIT);
    handleBlockEventClick();
  };

  const handleMenuItemClick = ({ key }) => {
    if (key === 'block-event') {
      handleBlockEventMenuItemClick();
    } else if (key === 'edit-block-event') {
      handleViewBlockEventMenuItemClick();
    }
  };

  let items: MenuProps['items'] = [
    {
      key: 'block-event',
      label: <span style={{ whiteSpace: 'nowrap' }}>Block Event</span>,
      disabled: !canBlock,
    },
  ];
  if (isBlocked) {
    items = [
      {
        key: 'edit-block-event',
        label: <span style={{ whiteSpace: 'nowrap' }}>View Block Details</span>,
      },
    ];
  }
  if (workbenchMode) {
    items = [];
  }

  return hasCreate ? (
    <div id="all-event-menu" onClick={(e) => e.stopPropagation()} style={{ height: '100%' }}>
      <Dropdown
        menu={{ items, onClick: handleMenuItemClick }}
        placement="bottomLeft"
        trigger={['click']}
        getPopupContainer={(triggerNode) =>
          triggerNode.parentElement?.parentElement?.parentElement ?? document.body
        }
      >
        <MoreOutlined
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '20px',
          }}
        />
      </Dropdown>
    </div>
  ) : null;
};
